import Loadable from "app/components/Loadable";
import React, { lazy } from "react";

const AddHoliday = Loadable(lazy(() => import("./AddHoliday.jsx")));
const EditHoliday = Loadable(lazy(() => import("./EditHoliday.jsx")));
const Holiday = Loadable(lazy(() => import("./holiday.jsx")));

const HolidayRoutes = [
    { path: "/holiday", element: <Holiday/> },
    { path: "/holiday/add-holiday", element: <AddHoliday/> },
    { path: "/holiday/edit-holiday", element: <EditHoliday/> },
];

export default HolidayRoutes;